import React from "react";

//
import "./gallery.component.scss";
import GalleryItem, { GalleryItemDataProps } from "./galleryItem.component";

interface Props {
  items: GalleryItemDataProps[];
  link: {
    allowlist: string;
    mint: string;
  }
}

const Gallery: React.FC<Props> = (props) => {
  return (
    <div className="gallery">
      <div className="gallery__wrapper">
        <div className="gallery__row">
          {props.items.map((item, key) => (
            <GalleryItem
              key={key}
              // link={props.link.allowlist}
              {...item}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
